export enum ButtonVariant {
  Primary,
  Secondary,
  Light,
  Outline
}
